/**
 * Map backend error messages to user-friendly i18n keys (devices namespace).
 */
export const DEVICE_ERROR_KEYS: Record<string, string> = {
  "timed out": "deviceErrorTimedOut",
  "device unreachable": "deviceErrorUnreachable",
  "Device did not respond": "deviceErrorDidNotRespond",
  "device returned FAILURE": "deviceErrorReturnedFailure",
  "device returned ERROR": "deviceErrorReturnedFailure",
  "device returned REFUSAL": "deviceErrorReturnedFailure",
}

/**
 * Resolve a backend error message to an i18n key, or undefined if unknown.
 */
export function getDeviceErrorI18nKey(
  errorMessage: string | null | undefined,
): string | undefined {
  if (errorMessage == null) return undefined
  return DEVICE_ERROR_KEYS[errorMessage]
}
